<kb-header
  [logo]="(logo$ | async)!"
  [appEditorId]="(editorialSettingsEditorId | async) ?? undefined"
>
  @for (title of titles$ | async; track title) {
    <kb-header-title [attr.color]="title.color" [href]="title.url">
      {{title.label}}
    </kb-header-title>
  }
  @if (navigation$ | async; as navigation) {
    <nav kb-site-navigation
      [navigation]="navigation"
    >
      @for (navigationCard of navigationCards$ | async | keyvalue; track navigationCard) {
        <kb-navigation-content [id]="navigationCard.key">
          <section kb-card class="navigation-card">
            <figure kb-overlay-figure slot="picture" [heading]="navigationCard.value.heading" [link]="navigationCard.value.link" [linkIcon]="null">
              <kb-picture [picture]="navigationCard.value.picture.sources" [alt]="navigationCard.value.picture.alt" [rootColumns]="3"></kb-picture>
            </figure>
            <div slot="content">
              <p kb-paragraph>
                {{navigationCard.value.content}}
              </p>
              @if (navigationCard.value.link) {
                <a
                  kb-standalone-link class="more-link"
                  [kbRouterOrExternalLink]="navigationCard.value.link.href"
                  [attr.target]="navigationCard.value.link.target"
                  i18n="content teaser read more link@@2827984212740060090"
                >Read more</a>
              }
            </div>
          </section>
        </kb-navigation-content>
      }
    </nav>
  } @else {
    <kb-progress-indicator kb-site-navigation-loader [visible]="true" size="dynamic"></kb-progress-indicator>
  }
  @if (regionSelector$ | async; as regionSelector) {
    <kb-region-select
      #regionSelectElement
      [regions]="regionSelector.availableRegions"
      [selectedRegion]="regionSelector.currentRegion"
      [selectedLanguage]="regionSelector.currentLanguage"
      (ngSubmit)="onRegionSelect($event)"
    ></kb-region-select>
  } @else {
    @if (languages$ | async; as languages) {
      <kb-language-select
        [languages]="languages"
        [ngModel]="selectedLanguage$ | async"
        (ngModelChange)="onSelectedLanguageChange($event)"
      ></kb-language-select>
    }
  }
  @if (searchUrl$ | async; as searchUrl) {
    @if (showGlobalSearch$ | async) {
      <a class="search-link" kb-icon [icon]="iconSearch" icon-centered icon-uppercase [kbRouterOrExternalLink]="searchUrl" [attr.aria-label]="headerSearchIntl.openSearchButtonLabel"></a>
    }
  }
</kb-header>
